import { message } from "antd";
import { useState } from "react";

import {
  postCustomApisArray,
  putCustomApisArray,
  deleteCustomApisArray,
  putCustomApis,
} from "V2.0/HomePages/Assistants/service";

export function useCustomAPIs({
  workspaceId,
  assistantId,
  customAPIs,
  syncAssistant,
}) {
  const { customAPIsArray, customAPIsEnabled } = customAPIs;
  const [loading, setLoading] = useState(false);

  const updateCustomApis = async (payload) => {
    message.loading("Updating");
    try {
      setLoading(true);
      const response = await putCustomApis({
        workspaceId,
        assistantId,
        payload,
      });
      if (response.status === 200) {
        message.destroy();
        message.success("Updated");
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            customAPIs: response.data,
          };
        });
      }
      setLoading(false);
    } catch (e) {
      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to update");
      setLoading(false);
    }
  };

  const addCustomApisArray = async (payload) => {
    message.loading("Adding Custom API");
    try {
      setLoading(true);
      const response = await postCustomApisArray({
        workspaceId,
        assistantId,
        payload,
      });
      if (response.status === 201) {
        message.destroy();
        message.success("Custom API added");
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            customAPIs: {
              ...prevAssistant.customAPIs,
              customAPIsArray: response.data,
            },
          };
        });
      }
      setLoading(false);
    } catch (e) {
      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to add Custom API");
      console.error("Error adding custom api");
      setLoading(false);
    }
  };

  const updateCustomApisArray = async (customApiId, payload) => {
    message.loading("Updating Custom API");
    try {
      setLoading(true);
      const response = await putCustomApisArray({
        workspaceId,
        assistantId,
        customApiId,
        payload,
      });
      if (response.status === 200) {
        message.destroy();
        message.success("Custom API updated");
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            customAPIs: {
              ...prevAssistant.customAPIs,
              customAPIsArray: response.data,
            },
          };
        });
      }
      setLoading(false);
    } catch (e) {
      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to update Custom API");
      console.error("Error updating custom api");
      setLoading(false);
    }
  };

  const removeCustomApisArray = async (customApiId) => {
    message.loading("Deleting Custom API");
    try {
      setLoading(true);
      const response = await deleteCustomApisArray({
        workspaceId,
        assistantId,
        customApiId,
      });
      if (response.status === 200) {
        message.destroy();
        message.success("Custom API deleted");
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            customAPIs: {
              ...prevAssistant.customAPIs,
              customAPIsArray: response.data,
            },
          };
        });
      }
      setLoading(false);
    } catch (e) {
      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to delete Custom API");
      console.error("Error adding custom api");
      setLoading(false);
    }
  };

  return {
    customAPIsArray,
    customAPIsEnabled,
    loading,
    updateCustomApis,
    addCustomApisArray,
    updateCustomApisArray,
    removeCustomApisArray,
  };
}
